import { supabase } from '../lib/supabase.js';

export class SmsService {
  // Send SMS using Supabase Edge Function
  static async sendSMS(phoneNumber, message) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-sms', {
        body: {
          to: phoneNumber,
          message: message
        }
      });

      if (error) {
        console.error('Error sending SMS:', error);
        return { success: false, error: error?.message };
      }

      return { success: true, data };
    } catch (error) {
      console.error('Unexpected error in sendSMS:', error);
      return { success: false, error: error?.message };
    }
  }

  // Generate ticket details SMS message
  static generateTicketSMS(booking) {
    const eventDate = new Date(booking?.event?.event_date);
    const formattedDate = eventDate?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    const formattedTime = eventDate?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });

    return `🎟️ TICKET DETAILS
Event: ${booking?.event?.title || 'N/A'}
Date: ${formattedDate} at ${formattedTime}
Venue: ${booking?.event?.venue_name || 'N/A'}
Location: ${booking?.event?.location || 'N/A'}

Ticket: ${booking?.ticket?.ticket_name || 'N/A'}
Quantity: ${booking?.quantity || 1}
Total: $${booking?.total_amount || '0.00'}

Booking Ref: ${booking?.booking_reference || 'N/A'}
Status: ${booking?.booking_status || 'N/A'}

Please arrive 30 minutes early for check-in. Bring this reference number or show your digital ticket.`;
  }

  // Send ticket details to phone number
  static async sendTicketDetails(booking, phoneNumber) {
    try {
      const message = this.generateTicketSMS(booking);
      return await this.sendSMS(phoneNumber, message);
    } catch (error) {
      console.error('Error sending ticket details:', error);
      return { success: false, error: error?.message };
    }
  }

  // Send bulk SMS to multiple attendees
  static async sendBulkSMS(attendees, message) {
    const results = [];
    
    for (const attendee of attendees) {
      if (attendee?.phone) {
        const result = await this.sendSMS(attendee?.phone, message);
        results?.push({
          attendee: attendee?.name || attendee?.full_name,
          phone: attendee?.phone,
          success: result?.success,
          error: result?.error
        });
      } else {
        results?.push({
          attendee: attendee?.name || attendee?.full_name,
          phone: 'N/A',
          success: false,
          error: 'No phone number provided'
        });
      }
    }

    return {
      success: true,
      results,
      totalSent: results?.filter(r => r?.success)?.length,
      totalFailed: results?.filter(r => !r?.success)?.length
    };
  }

  // Validate phone number format
  static validatePhoneNumber(phoneNumber) {
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    return phoneRegex?.test(phoneNumber?.replace(/[\s\-\(\)]/g, ''));
  }

  // Format phone number for Twilio
  static formatPhoneNumber(phoneNumber) {
    const cleaned = phoneNumber?.replace(/[\s\-\(\)]/g, '');
    if (cleaned?.startsWith('+')) {
      return cleaned;
    }
    if (cleaned?.startsWith('1') && cleaned?.length === 11) {
      return `+${cleaned}`;
    }
    if (cleaned?.length === 10) {
      return `+1${cleaned}`;
    }
    return cleaned;
  }
}

export default SmsService;